/* zapachydoauta.pl - konfigurator: podglad na zywo, ksztalty, zapach, ilosc, koszyk.
   USUWANIE TLA ("Bez tla"): AI dzialajaca w przegladarce klienta (biblioteka ladowana
   w theme.liquid), z automatycznym fallbackiem na metode "jednolite tlo" gdy AI
   nie zdazy sie zaladowac. Po wycieciu dodaje biala obwodke i przycina do granic obiektu. */
(function () {
  var SHAPES = {
    prostokat: { label: 'Prostokat', clip: 'none', w: 240, h: 320, fit: 'cover', radius: '16px' },
    kwadrat:   { label: 'Kwadrat',   clip: 'none', w: 290, h: 290, fit: 'cover', radius: '6px' },
    serce:     { label: 'Serce',     clip: 'polygon(50% 100%,85% 55%,100% 32%,95% 15%,80% 8%,63% 15%,50% 28%,37% 15%,20% 8%,5% 15%,0% 32%,15% 55%)', w: 300, h: 285, fit: 'cover', radius: '0' },
    plain:     { label: 'Bez tla',   clip: 'none', w: 300, h: 220, fit: 'cover', radius: '0' }
  };

  function init(root) {
    var state = { shape: 'prostokat', scent: null, qty: 1, img: null, processed: null, processing: false };
    function payQty(q) { return q; }

    var tag = root.querySelector('[data-zda-tag]');
    var imgEl = root.querySelector('[data-zda-img]');
    var ph = root.querySelector('[data-zda-placeholder]');
    var hole = root.querySelector('[data-zda-hole]');
    var shapeLabel = root.querySelector('[data-zda-shapelabel]');
    var fileInput = root.querySelector('[data-zda-file]');
    var qtyEl = root.querySelector('[data-zda-qtyval]');
    var qtyField = root.querySelector('[data-zda-qtyfield]');
    var totalEl = root.querySelector('[data-zda-total]');
    var addBtn = root.querySelector('[data-zda-add]');
    var bgBox = root.querySelector('[data-zda-bgbox]');
    var bgStatus = root.querySelector('[data-zda-bgstatus]');
    var bgBtn = root.querySelector('[data-zda-bgbtn]');
    var propShape = root.querySelector('[data-zda-prop-shape]');
    var propScent = root.querySelector('[data-zda-prop-scent]');
    var price = parseFloat(root.getAttribute('data-zda-price') || '30');

    var isPlain = function () { return state.shape === 'plain'; };
    function previewImg() {
      if (isPlain() && state.processed) return state.processed;
      if (isPlain()) return null;
      return state.img;
    }
    function render() {
      var sh = SHAPES[state.shape];
      if (shapeLabel) shapeLabel.textContent = sh.label;
      tag.style.width = sh.w + 'px';
      tag.style.height = sh.h + 'px';
      tag.style.clipPath = isPlain() ? 'none' : sh.clip;
      tag.style.borderRadius = isPlain() ? '0' : (sh.radius || '0');
      tag.style.background = isPlain() ? 'transparent' : '#f4f2ec';
      tag.style.boxShadow = isPlain() ? 'none' : '0 26px 50px rgba(0,0,0,.55)';
      tag.style.alignItems = isPlain() ? 'flex-start' : 'center';

      var showLoading = isPlain() && state.img && !state.processed;
      if (ph) {
        if (showLoading) {
          ph.style.display = 'flex';
          ph.innerHTML = '<div style="width:26px;height:26px;border-radius:99px;border:2px solid #3a3a3a;border-top-color:#f4f2ec;animation:zdaspin .8s linear infinite;"></div><div class="zda-mono" style="font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:#cfccc4;margin-top:12px;">Wycinam tlo...</div>';
          ph.style.background = 'transparent';
        } else if (!ph.getAttribute('data-zda-orig-set')) {
          ph.setAttribute('data-zda-orig-set', '1');
          ph._origHtml = ph.innerHTML;
        }
      }
      var src = previewImg();
      if (src) {
        imgEl.src = src; imgEl.style.display = 'block';
        if (isPlain()) {
          imgEl.style.objectFit = 'contain';
          imgEl.style.maxWidth = '92%'; imgEl.style.maxHeight = '96%';
          imgEl.style.width = 'auto'; imgEl.style.height = 'auto';
          imgEl.style.marginTop = '2px';
        } else {
          imgEl.style.objectFit = sh.fit;
          imgEl.style.maxWidth = ''; imgEl.style.maxHeight = '';
          imgEl.style.width = '100%'; imgEl.style.height = '100%';
          imgEl.style.marginTop = '0';
        }
        imgEl.style.filter = 'none';
        if (ph && !showLoading) ph.style.display = 'none';
      } else {
        imgEl.style.display = 'none';
        if (ph) {
          if (!showLoading) {
            if (ph._origHtml) ph.innerHTML = ph._origHtml;
            ph.style.background = 'repeating-linear-gradient(45deg,#eceae1,#eceae1 9px,#e2dfd5 9px,#e2dfd5 18px)';
            ph.style.display = 'flex';
          }
        }
      }
      if (hole) hole.style.display = 'block';
      root.querySelectorAll('[data-zda-shape]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-zda-shape') === state.shape);
      });
      if (bgBox) bgBox.style.display = 'none';
      if (qtyEl) qtyEl.textContent = state.qty;
      if (qtyField) qtyField.value = state.qty;
      if (totalEl) totalEl.textContent = fmt(payQty(state.qty) * price) + ' zl';
      if (propShape) propShape.value = sh.label;
      if (propScent) propScent.value = state.scent || '';
    }
    function fmt(n) { return (Math.round(n * 100) / 100).toString().replace('.', ','); }

    root.querySelectorAll('[data-zda-shape]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.shape = b.getAttribute('data-zda-shape');
        render();
        if (isPlain() && state.img && !state.processed && !state.processing) removeBg();
      });
    });
    root.querySelectorAll('[data-zda-scent]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.scent = b.getAttribute('data-zda-scent');
        root.querySelectorAll('[data-zda-scent]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        render();
      });
    });
    if (fileInput) fileInput.addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      var r = new FileReader();
      r.onload = function () {
        state.img = r.result; state.processed = null; render();
        if (isPlain()) removeBg();
      };
      r.readAsDataURL(f);
    });

    var appSlot = root.querySelector('[data-zda-app-slot]') || root.querySelector('.upload-lift');
    function useFile(f) {
      if (!f) return;
      var r = new FileReader();
      r.onload = function () {
        state.img = r.result; state.processed = null; render();
        if (isPlain()) removeBg();
      };
      r.readAsDataURL(f);
    }
    if (appSlot) {
      appSlot.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.type === 'file' && t.files && t.files[0]) useFile(t.files[0]);
      }, true);
      var lastSrc = '';
      function scanImg() {
        var imgs = appSlot.querySelectorAll('img');
        for (var i = 0; i < imgs.length; i++) {
          var src = imgs[i].currentSrc || imgs[i].src || '';
          if (src && src !== lastSrc && /^(blob:|data:|https?:)/.test(src)) {
            lastSrc = src; state.img = src; state.processed = null; render();
            if (isPlain()) removeBg();
            return;
          }
        }
      }
      new MutationObserver(scanImg).observe(appSlot, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
      scanImg();
    }

    var minus = root.querySelector('[data-zda-minus]'); var plus = root.querySelector('[data-zda-plus]');
    if (minus) minus.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); render(); });
    if (plus) plus.addEventListener('click', function () { state.qty += 1; render(); });

    function loadImage(src) {
      return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = src; });
    }
    function blobToDataUrl(blob) {
      return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r.readAsDataURL(blob); });
    }
    function waitForBgLib(timeoutMs) {
      return new Promise(function (res, rej) {
        var t0 = Date.now();
        (function poll() {
          if (window.__zdaRemoveBg) return res(window.__zdaRemoveBg);
          if (Date.now() - t0 > timeoutMs) return rej(new Error('bg-lib-unavailable'));
          setTimeout(poll, 120);
        })();
      });
    }
    function downscale(src, maxDim) {
      return loadImage(src).then(function (img) {
        var w = img.naturalWidth, h = img.naturalHeight;
        var sc = Math.min(1, maxDim / Math.max(w, h));
        w = Math.max(1, Math.round(w * sc)); h = Math.max(1, Math.round(h * sc));
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        cv.getContext('2d').drawImage(img, 0, 0, w, h);
        return cv.toDataURL('image/png');
      });
    }
    function floodFillCutout(src) {
      return loadImage(src).then(function (img) {
        var w = img.naturalWidth, h = img.naturalHeight;
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d'); ctx.drawImage(img, 0, 0, w, h);
        var id = ctx.getImageData(0, 0, w, h), d = id.data;
        var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + (w - 1)) * 4];
        var br = 0, bg = 0, bb = 0;
        corners.forEach(function (o) { br += d[o]; bg += d[o + 1]; bb += d[o + 2]; });
        br /= 4; bg /= 4; bb /= 4;
        var thr2 = 46 * 46, vis = new Uint8Array(w * h), q = [];
        function push(x, y) { if (x < 0 || y < 0 || x >= w || y >= h) return; var i = y * w + x; if (vis[i]) return; vis[i] = 1; q.push(i); }
        for (var x = 0; x < w; x++) { push(x, 0); push(x, h - 1); }
        for (var y = 0; y < h; y++) { push(0, y); push(w - 1, y); }
        while (q.length) {
          var i = q.pop(), o = i * 4;
          var dr = d[o] - br, dg = d[o + 1] - bg, db = d[o + 2] - bb;
          if (dr * dr + dg * dg + db * db <= thr2) { d[o + 3] = 0; var px = i % w, py = (i / w) | 0; push(px + 1, py); push(px - 1, py); push(px, py + 1); push(px, py - 1); }
        }
        ctx.putImageData(id, 0, 0);
        return cv.toDataURL('image/png');
      });
    }
    function outlineAndCrop(src) {
      return loadImage(src).then(function (img) {
        var w = img.naturalWidth, h = img.naturalHeight;
        var R = Math.max(3, Math.round(Math.min(w, h) * 0.022));
        var pad = R + 4;
        var sil = document.createElement('canvas'); sil.width = w; sil.height = h;
        var sctx = sil.getContext('2d');
        sctx.drawImage(img, 0, 0, w, h);
        sctx.globalCompositeOperation = 'source-in';
        sctx.fillStyle = '#ffffff';
        sctx.fillRect(0, 0, w, h);
        sctx.globalCompositeOperation = 'source-over';
        var outW = w + pad * 2, outH = h + pad * 2;
        var out = document.createElement('canvas'); out.width = outW; out.height = outH;
        var octx = out.getContext('2d');
        var radii = [R, R * 0.66, R * 0.33], steps = 20;
        radii.forEach(function (r) {
          for (var i = 0; i < steps; i++) {
            var a = (i / steps) * Math.PI * 2;
            octx.drawImage(sil, pad + Math.cos(a) * r, pad + Math.sin(a) * r);
          }
        });
        octx.drawImage(img, pad, pad, w, h);
        var id = octx.getImageData(0, 0, outW, outH), d = id.data;
        var minX = outW, minY = outH, maxX = -1, maxY = -1;
        for (var y = 0; y < outH; y++) {
          for (var x = 0; x < outW; x++) {
            var a2 = d[(y * outW + x) * 4 + 3];
            if (a2 > 8) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
          }
        }
        if (maxX < minX) { minX = 0; minY = 0; maxX = outW - 1; maxY = outH - 1; }
        var bp = 4;
        minX = Math.max(0, minX - bp); minY = Math.max(0, minY - bp);
        maxX = Math.min(outW - 1, maxX + bp); maxY = Math.min(outH - 1, maxY + bp);
        var cw = maxX - minX + 1, ch = maxY - minY + 1;
        var cropped = document.createElement('canvas'); cropped.width = cw; cropped.height = ch;
        cropped.getContext('2d').drawImage(out, minX, minY, cw, ch, 0, 0, cw, ch);
        return cropped.toDataURL('image/png');
      });
    }
    function removeBg() {
      if (!state.img) return;
      var src = state.img;
      state.processing = true; render();
      downscale(src, 900).then(function (small) {
        return waitForBgLib(15000).then(function (removeBgFn) {
          return fetch(small).then(function (r) { return r.blob(); }).then(function (blob) {
            return removeBgFn(blob);
          }).then(blobToDataUrl);
        }).catch(function () {
          return floodFillCutout(small);
        });
      }).then(function (cutout) {
        return outlineAndCrop(cutout);
      }).then(function (finalUrl) {
        if (state.img !== src) return;
        state.processed = finalUrl; state.processing = false; render();
      }).catch(function () {
        if (state.img !== src) return;
        state.processed = src; state.processing = false; render();
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-zda-configurator]').forEach(function (el) {
      if (el.getAttribute('data-zda-ready') === '1') return;
      el.setAttribute('data-zda-ready', '1');
      init(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-zda-configurator]').forEach(function (el) {
      el.setAttribute('data-zda-ready', '1');
      init(el);
    });
  });
})();